module.exports = __webpack_public_path__ + "static/media/Paraguay.c5e0347d.png";